import axios from 'axios';
import store from '../store';
import { Message } from 'element-ui';

// 用于计算所有请求次数，等待所有请求结束后再关闭loading动画
let loadingCount = 0;

const instance = axios.create({
  timeout: window.TIME || 60 * 1000, // 多长时间请求无果后结束
  // baseURL: '/api', // 接口地址在config.js中定义
  baseURL: window.BASE_URL, // 接口地址在config.js中定义
});

const CancelToken = axios.CancelToken; // 需要通过这个token主动关闭axios请求
instance.interceptors.request.use(
  (req) => {
    const source = CancelToken.source();
    req.cancelToken = source.token;
    store.commit('addRequest', source);
    loadingCount++;
    store.commit('loadStatus', true);
    return req;
  },
  (error) => error
);
instance.interceptors.response.use(
  (res) => {
    loadingCount--;
    if (loadingCount == 0) store.commit('loadStatus', false);
    
    // 兼容后端返回 200 或 1000 作为成功状态码
    if (res.data && res.data.code !== 200 && res.data.code !== '1000') {
      Message.error(res.data.message || '请求失败');
    }
    
    if (res.status == 200) return res.data;
    return res;
  },
  (err) => {
    loadingCount--;
    if (loadingCount == 0) store.commit('loadStatus', false);
    
    if (
      err.code === 'ECONNABORTED' &&
      err.message.indexOf('timeout') !== -1 &&
      !err.config._retry
    ) {
      return Message.error('请求数据失败，请稍后再试');
    }
    
    // 安全访问 err.response，网络错误时 response 可能为 undefined
    const { response } = err;
    if (response) {
      errorHandle(response.status, response.data);
      return response;
    } else {
      // 网络错误或请求被取消
      Message.error(err.message || '网络连接失败');
      return Promise.reject(err);
    }
  }
);
const errorHandle = (status, other) => {
  switch (status) {
    case 400:
      Message.error('信息校验失败');
      break;
    case 401:
      Message.error('认证失败');
      break;
    case 403:
      Message.error('token校验失败');
      break;
    case 404:
      Message.error('请求的资源不存在');
      break;
    default:
      Message.error(other);
      break;
  }
};

export default instance;
